var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64992 5.49977L9.70725 2.44244C9.89476 2.25484 10.0001 2.00044 10 1.7352C9.99994 1.46996 9.89451 1.21561 9.70692 1.0281C9.51932 0.840595 9.26492 0.735289 8.99968 0.735352C8.73444 0.735414 8.48009 0.84084 8.29258 1.02844L5.23592 4.08577C5.20495 4.11681 5.16817 4.14144 5.12767 4.15824C5.08717 4.17505 5.04376 4.1837 4.99991 4.1837C4.95607 4.1837 4.91266 4.17505 4.87216 4.15824C4.83166 4.14144 4.79488 4.11681 4.76391 4.08577L1.70725 1.02844C1.51974 0.84084 1.26539 0.735414 1.00015 0.735351C0.734912 0.735289 0.480513 0.840594 0.292915 1.0281C0.105319 1.21561 -0.000107797 1.46996 -0.000169798 1.7352C-0.000232752 2.00044 0.105073 2.25484 0.292581 2.44244L3.34991 5.49977C3.78794 5.93659 4.38131 6.18189 4.99991 6.18189C5.61852 6.18189 6.21189 5.93659 6.64992 5.49977Z",
    fill: "#D69B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.8a1ca62b1544565312f6c4b92b1a1272.svg";
export { ForwardRef as ReactComponent };